import React from 'react';
import { Box } from '@mui/material';
import DeliveryLogsRow from './DeliveryLogsRow';

/**
 * DeliveryLogsTable component displays delivery logs in a list layout
 * @param {Array} deliveryLogs - Array of delivery log objects
 * @param {string} selectedDeliveryLogId - Currently selected delivery log ID for highlighting
 */
const DeliveryLogsTable = ({ deliveryLogs, selectedDeliveryLogId }) => {
  return (
    <Box>
      {deliveryLogs.map((deliveryLog, index) => (
        <DeliveryLogsRow
          key={deliveryLog.id}
          deliveryLog={deliveryLog}
          isLast={index === deliveryLogs.length - 1}
          selectedDeliveryLogId={selectedDeliveryLogId}
        />
      ))}
    </Box>
  );
};

export default DeliveryLogsTable;
